// import React from "react";
// import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

// import LandingPage from "./pages/LandingPage";
// import LoginPage from "./pages/LoginPage";
// import DashboardPage from "./pages/DashboardPage";
// import TwoFactorSetupPage from "./pages/TwoFactorSetupPage";

// import ProtectedLayout from "./components/ProtectedLayout";
// import AuthWatcher from "./components/AuthWatcher";

// function App() {
//   return (
//     <Router>
//       <AuthWatcher />

//       <Routes>
//         {/* Public routes */}
//         <Route path="/" element={<LandingPage />} />
//         <Route path="/login" element={<LoginPage />} />
//         <Route path="/2fa/setup" element={<TwoFactorSetupPage />} />

//         {/* Protected routes */}
//         <Route element={<ProtectedLayout />}>
//           <Route path="/home" element={<DashboardPage />} />
//           {/* future protected pages go here */}
//           {/* <Route path="/reports" element={<ReportsPage />} /> */}
//         </Route>

//         {/* Catch-all */}
//         <Route path="*" element={<Navigate to="/" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";

import LandingPage from "./pages/LandingPage";
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import TwoFactorSetupPage from "./pages/TwoFactorSetupPage";
import ProtectedLayout from "./components/ProtectedLayout";
// import DashboardLayout from "./layouts/DashboardLayout";

function App() {
  return (
    <Router>
      <Routes>
        {/* Public routes */}
        <Route path="/" element={<LandingPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/2fa/setup" element={<TwoFactorSetupPage />} />

        {/* Protected routes */}
        <Route element={<ProtectedLayout />}>
          <Route path="/home" element={<DashboardPage />} />
          {/* future protected pages */}
        </Route>

        {/* Catch-all */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
